import React from 'react';
import { Logo } from '../../../../components/common/Logo';
import { Clock, RefreshCw } from 'lucide-react';
import { Button } from '../../../../components/common/Button';
import { useInterview } from '../../contexts/InterviewContext';

interface InterviewNavbarProps {
  isMobileView?: boolean;
}

const InterviewNavbar: React.FC<InterviewNavbarProps> = ({ 
  isMobileView = false 
}) => {
  const { 
    interviewDetails, 
    elapsedTime, 
    formatTime, 
    connected,
    handleRestartInterview 
  } = useInterview();

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-white/20 dark:bg-slate-900/20 transition-all duration-300 py-3 border-b border-border-light/10 dark:border-border-dark/10 shadow-sm">
      <div className="container mx-auto max-w-8xl px-4 md:px-6 flex items-center justify-between h-14">
        <div className="flex items-center">
          <Logo /> {/* Logo with no action */}
          
          <div className="ml-4 hidden sm:block">
            <h1 className="font-heading font-semibold text-lg text-text-primary-light dark:text-text-primary-dark">
              {interviewDetails?.title || 'Interview'}
            </h1>
            {(interviewDetails?.company || interviewDetails?.jobRole) && (
              <p className="text-xs text-text-secondary-light dark:text-text-secondary-dark">
                {interviewDetails?.company}{interviewDetails?.jobRole && ` • ${interviewDetails.jobRole}`}
              </p>
            )}
          </div>
        </div>
        
        <div className="flex items-center space-x-3">
          {/* Timer Chip */}
          <div className="flex items-center space-x-1 px-3 py-3 bg-primary-light/10 dark:bg-primary-dark/10 
            text-primary-light dark:text-primary-dark rounded-full border border-primary-light/20 
            dark:border-primary-dark/30 hover:bg-primary-light/15 dark:hover:bg-primary-dark/25 transition-all duration-200">
            <Clock size={16} className="mr-1 text-primary-light dark:text-primary-dark" />
            <span className="text-sm font-medium">
              {formatTime(elapsedTime)}
              {/* {!isMobileView && ` / ${formatTime(totalDuration)}`} */}
            </span>
          </div>
          
          {/* Connection status indicator */}
          <div className={`hidden md:flex items-center space-x-1 px-3 py-3 rounded-full border transition-all duration-200
            ${connected 
              ? 'bg-green-500/10 text-green-500 border-green-500/20 dark:bg-green-500/10 dark:text-green-500 dark:border-green-500/20' 
              : 'bg-amber-500/10 text-amber-500 border-amber-500/20 dark:bg-amber-500/10 dark:text-amber-500 dark:border-amber-500/20'}`}>
            <span className={`w-2 h-2 rounded-full mr-1.5 ${connected ? 'bg-green-500' : 'bg-amber-500'}`}></span>
            <span className="text-xs font-medium">{connected ? 'Connected' : 'Connecting...'}</span>
          </div>
          
          {/* Restart Button, Commented out for now */}
          {/* <Button 
            variant="outline" 
            size="sm" 
            onClick={handleRestartInterview}
            className="min-w-[40px] sm:min-w-[90px] py-3"
            leftIcon={!isMobileView ? <RefreshCw size={16} /> : null}
          >
            {isMobileView ? <RefreshCw size={16} /> : <span>Restart</span>}
          </Button> */}
        </div>
      </div> 
    </nav>
  );
};

export default InterviewNavbar; 